import { createSlice } from '@reduxjs/toolkit';
import { NavigationItemType } from '../../common/interfaces/NavigationItemType';
import { AdminDashboardRoute } from './AdminDashboardRoute';
import editIcon from '../../assets/icons/edit.svg';
import settingsIcon from '../../assets/icons/setting.svg';
import subscriptionsIcon from '../../assets/icons/subscriptions.svg';
import editBlueIcon from '../../assets/icons/edit-blue.svg';
import settingsBlueIcon from '../../assets/icons/setting-blue.svg';
import subscriptionsBlueIcon from '../../assets/icons/subscriptions-blue.svg';
import AppRoutes from '../App/AppRoutes';

interface AdminDashboardState {
  navItems: Array<NavigationItemType>;
}

const initialState: AdminDashboardState = {
  navItems: [
    {
      label: 'Administrators',
      icon: editIcon,
      activeIcon: editBlueIcon,
      linkUrl: `/${AppRoutes.ADMIN_DASHBOARD_PATH}${AdminDashboardRoute.ADMINISTRATORS}`,
    },
    {
      label: 'Sectors management',
      icon: subscriptionsIcon,
      activeIcon: subscriptionsBlueIcon,
      linkUrl: `/${AppRoutes.ADMIN_DASHBOARD_PATH}${AdminDashboardRoute.SECTORS_MANAGEMENT}`,
    },
    {
      label: 'Code injection',
      icon: settingsIcon,
      activeIcon: settingsBlueIcon,
      linkUrl: `/${AppRoutes.ADMIN_DASHBOARD_PATH}${AdminDashboardRoute.CODE_INJECTION}`,
    },
  ],
};

export const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {},
});

export default adminDashboardSlice.reducer;
